const adminChatsRoutes = [
    { path: 'chats/:package_id', name: 'chats', component: () => import('pages/sot.bot.admin/chats/ChatsList.vue') }, // чаты,
    { path: 'chats/:package_id/add', name: 'add-chat', component: () => import('pages/sot.bot.admin/operators/OperatorChatEdit.vue') },
    { path: 'chats/:package_id/:id', name: 'chat', component: () => import('pages/sot.bot.admin/operators/OperatorChat.vue') }, // чаты,
    { path: 'chats/:package_id/edit/:id', name: 'edit-chat', component: () => import('pages/sot.bot.admin/operators/OperatorChatEdit.vue') }, // чаты,
];

export default adminChatsRoutes;
